import React from 'react';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import { transformHtmlTagsToText } from '../../../util';
import * as Styled from './styled';

interface ReportLeaseGeneralColumnProps {
  cell: TableCell;
}

function ReportLeaseGeneralColumn({
  cell,
}: ReportLeaseGeneralColumnProps): JSX.Element {
  const displayedValue = transformHtmlTagsToText(cell.value);

  return (
    <Styled.ReportLeaseGeneralColumn>
      {displayedValue}
    </Styled.ReportLeaseGeneralColumn>
  );
}

export default ReportLeaseGeneralColumn;
